export const AUTH = {
  tabLogin: 'auth-tab-login',
  tabSignup: 'auth-tab-signup',
  nameInput: 'auth-name-input',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  submitButton: 'auth-submit-button',
  googleButton: 'google-login-button',
  quickAdminButton: 'quick-login-admin-button',
  quickCustomerButton: 'quick-login-customer-button',
  logoutButton: 'auth-logout-button',
  errorMessage: 'auth-error-message',
};

export const PUBLIC_TRACK = {
  trackingInput: 'tracking-number-input',
  trackButton: 'track-shipment-button',
  samplePill: 'sample-tracking-pill-',
  resultContainer: 'tracking-result-container',
  timeline: 'shipment-timeline-steps',
  statusBadge: 'shipment-status-badge',
  printButton: 'print-receipt-button',
  notFound: 'tracking-not-found',
};

export const ADMIN = {
  navLink: 'nav-admin-dashboard',
  openCreate: 'admin-create-shipment-button',
  form: 'admin-shipment-form',
  senderName: 'shipment-sender-name',
  senderAddress: 'shipment-sender-address',
  receiverName: 'shipment-receiver-name',
  receiverAddress: 'shipment-receiver-address',
  origin: 'shipment-origin',
  destination: 'shipment-destination',
  weight: 'shipment-weight',
  packageType: 'shipment-package-type',
  serviceTier: 'shipment-service-tier',
  customerEmail: 'shipment-customer-email',
  notes: 'shipment-notes',
  submit: 'submit-create-shipment',
  search: 'admin-search-shipments-input',
  filterStatus: 'admin-filter-status-select',
  table: 'admin-shipments-table',
  row: 'shipment-table-row-',
  updateStatus: 'update-shipment-status-select-',
  viewReceipt: 'view-receipt-button-',
};

export const CUSTOMER = {
  navLink: 'nav-customer-shipments',
  grid: 'customer-shipments-grid',
  card: 'customer-shipment-card-',
};
